<template>
  <div class="printOrderListBox">
    <div class="printOrderListBoxVon">
      <el-tabs
        v-model="modelStatus"
        class="orderListTabs"
        @tab-click="searchInfo"
      >
        <el-tab-pane
          v-for="item in tabList"
          :key="item.id"
          :label="item.name"
          :name="item.id"
        >
        </el-tab-pane>
      </el-tabs>
      <div>
        <div class="orderSearchBox">
            <div class="timeSearch">
                <span style="color: #b2b2b2;">创建时间</span>
                <el-date-picker
                    v-model="createDate"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="—"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
          <el-input v-model="modelName" placeholder="模型名称"></el-input>
          <el-input v-model="designerName" placeholder="设计师名称"></el-input>
          <el-input v-model="buyerName" placeholder="买家名称"></el-input>
          <!--<el-input-->
            <!--v-model="merchantNameValue"-->
            <!--placeholder="作者名称"-->
          <!--&gt;</el-input>-->
          <el-input v-model="orderNo" placeholder="订单编号"></el-input>
          <!--          <el-select v-model="modelStatus" placeholder="订单状态">
              <el-option label="全部" value=""> </el-option>
              <el-option label="待付款" value="UN_PAY"> </el-option>
              <el-option label="待评价" value="UN_APPRAISE"> </el-option>
              <el-option label="完成" value="FINISHED"> </el-option>
          </el-select>-->
          <!--<el-select v-model="evaluateStatusValue" placeholder="评价状态">-->
            <!--<el-option label="好评" value="好评"> </el-option>-->
            <!--<el-option label="中评" value="中评"> </el-option>-->
            <!--<el-option label="差评" value="差评"> </el-option>-->
          <!--</el-select>-->
            <el-select v-model="isFree" placeholder="付费类型">
                <el-option label="免费" :value="true"> </el-option>
                <el-option label="付费" :value="false"> </el-option>
            </el-select>
          <el-button class="searchBtn" @click="searchInfo"
            >搜索</el-button
          >
          <el-button type="text" class="resetBtn" @click="reset">
            <i class="iconfont icon-qingchushujuku"></i>
            <span>清除条件</span>
          </el-button>
        </div>
        <div class="orderListTable">
          <ul class="tableHeader">
            <li class="name">模型名称</li>
            <li class="payment">一级分类</li>
            <li class="payment">二级分类</li>
            <li class="price">模型描述</li>
            <li class="payment">实付款</li>
            <li class="status">订单状态</li>
            <!--<li class="operation">操作</li>-->
          </ul>
          <ul class="tableBody"  v-if="modelOrderList.length != 0" v-loading="loading">
            <li
              class="bodyItem"
              v-for="(items, index) in modelOrderList"
              :key="index"
            >
              <div class="itemTop">
                <div>创建时间：{{ items.orderBase.createDate }}</div>
                <div>订单编号：{{ items.orderBase.orderNo }}</div>
                <div class="merchantInfo">
                  <img :src="items.userImg" alt="" width="80px" />
                  <span>{{ items.modelCreatorName }}</span>
                </div>
              </div>
              <div class="itemBottom">
                <div class="name">
                  <div class="orderInfo">
                    <div class="orderInfoImg">
                      <img :src="items.modelImg" alt="" />
                      <!--<button>预览</button>-->
                    </div>
                    <div class="infoContent">
                      <div class="infoName">{{ items.modelName }}</div>
                    </div>
                  </div>
                </div>
                <div class="payment">
                  {{ items.typeFirstName }}
                </div>
                <div class="payment">
                  {{ items.typeFirstName }}
                </div>
                <div class="price">
                  {{ items.modelRemark }}
                </div>
                <div class="payment">
                  <h3>¥{{ items.orderBase.totalPrice }}</h3>
                  <el-button type="text" class="operationBtn" @click="modelOrderDetailsbtn(items.uuid)">订单详情</el-button>
                </div>
                <div class="status">
                  <div class="statusName">{{ items.modelStatusCn }}</div>
                </div>
                <!--<div class="operation"></div>-->
              </div>
            </li>
          </ul>
            <div class="orderNomesaage" v-loading="loading" v-else >暂无数据</div>
        </div>
      </div>
      <el-pagination
        v-if="modelOrderList.length != 0"
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getModelOrderList } from "../../utils/interface";
export default {
  name: "printOrderList",
  data() {
    return {
        loading: true,
      modelStatus: "",
        isFree:null,
      tabList: [
        {
          id: "",
          name: "全部",
        },
        {
          id: "UN_PAY",
          name: "待付款",
        },
        {
          id: "UN_APPRAISE",
          name: "待评价",
        },
        {
          id: "FINISHED",
          name: "完成",
        },
      ],
      createDate: null,
      modelName: "",
      designerName: "",
      buyerName: "",
      merchantNameValue: "",
      orderNo: "",
      evaluateStatusValue: "",
      postSalesServiceValue: "",
      modelOrderList: [],
      pageNo: 1,
      total: 100,
      pageSize: 5,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.reset();
      this.pageNo = 1;
      this.getModelOrderList();
    },
      searchInfo(){
          this.pageNo = 1;
          this.getModelOrderList();
      },
    // 检索重置
    reset() {
      this.modelName = "";
      this.designerName = "";
      this.buyerName = "";
      this.orderNo = "";
      // this.modelStatus = ''
      this.createDate = null;
      this.getModelOrderList();
    },
    getModelOrderList() {
        this.loading = true;
      let params = {
        modelName: this.modelName,
        designerName: this.designerName,
        buyerName: this.buyerName,
        orderNo: this.orderNo,
        modelStatus: this.modelStatus == 0 ? "" : this.modelStatus,
        createDate:
          this.createDate == null
            ? null
            : this.createDate.join(" - "),
          isFree: this.isFree,
        current: this.pageNo,
        pageSize: this.pageSize,
      };
      getModelOrderList(params).then((res) => {
        this.modelOrderList = res.list;
        this.total = res.total;
          this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getModelOrderList();
    },
    handleBatchDownload(val) {},
    modelOrderDetailsbtn(id){
        this.$router.push({
            path: '/modelOrderDetails',
            query: {
                uuid: id
            }
        })
    }

  },
};
</script>

<style scoped lang="less">
.printOrderListBox {
    background: #fff;
    min-height: 1011px;
    padding: 94px 20px 20px;
    margin-left: 20px;
    .orderListTabs{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 999;
        background: #fff;
        width: 100%;
        padding: 20px;
        margin-left: 20px;
    }
    /deep/ .el-tabs__item {
        padding: 0 25px !important;
        text-align: center;

        &:hover {
            color: #3686d7
        }

        &:after {
            content: "";
            position: absolute;
            right: 0;
            bottom: 12px;
            width: 1px;
            height: 15px;
            background-color: #E4E7ED;
            z-index: 1;
        }

        &:last-child:after {
            content: "";
            width: 0;
            height: 0;
        }
    }
    /deep/ .el-tabs__active-bar {
        height: 3px;
        background-color: #3686d7;
    }
    /deep/ .el-tabs__item.is-active {
        color: #3686d7
    }
    /deep/ .el-tabs__nav-wrap::after {
        height: 1px;
    }

  .orderSearchBox {
      .timeSearch {
          background-color: #f2f4f7;
          height: 35px;
          display: flex;
          align-items: center;
          margin-bottom: 22px;
          margin-right: 30px;
          border-radius: 8px;

          span {
              font-size: 12px;
              color: #c0c4cc !important;
              font-weight: normal;
              padding-left: 15px;
              margin-right: 5px;
          }

          // /deep/ .el-range-input{
          //         background-color: #f2f4f7;
          //             &:hover, &:focus {
          //             background-color: #fff;
          //             // border: 1px solid #108EE9;
          //         }
          // }
          /deep/ input::-webkit-input-placeholder {
              color: #c0c4cc;
              font-size: 12px;
          }

          /deep/ .el-range-input:hover {
              background-color: #fff !important;
          }

          /deep/ .el-date-editor .el-range-separator {
              line-height: 25px;
              color: #c0c4cc;
          }

          /deep/ .el-date-editor .el-range__close-icon {
              line-height: 28px;
          }

          /deep/ .el-input__inner:hover .el-range-input, /deep/ .el-input__inner:focus .el-range-input {
              background-color: white;
          }

          /deep/ .el-input__inner {
              width: 225px;
              height: 35px;
              min-height: 35px;
              font-size: 12px;
              color: #999999;
              background-color: #f2f4f7;
              border: 1px solid #f2f4f7;
              border-radius: 5px;

              .el-range-input {
                  background-color: #f2f4f7;
              }

              &:hover, &:focus {
                  background-color: #fff;
                  border: 1px solid #108EE9;

              }
          }
      }
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
    }

    .resetBtn {
      color: #333333;
    }
  }

  .orderListTable {
      .orderNomesaage {
          color: #888;
          text-align: center;
          padding: 15px 0;
      }
    .tableHeader {
      display: flex;
      width: 100%;
      height: 35px;
      line-height: 35px;
      background: #f3f7ff;
      border-radius: 5px;
      margin: 0 0 15px;
      li {
        text-align: center;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
      }
    }

    .tableBody {
      li {
        width: 100%;
        border: 1px solid #f2f2f2;
        border-radius: 10px;
        margin-bottom: 16px;

        .itemTop {
          width: 100%;
          height: 42px;
          background: #ebf3fb;
          line-height: 42px;
          font-size: 14px;
          color: #333;
          padding: 0 20px;
          display: flex;
          align-items: center;
          position: relative;

          div {
            margin-right: 30px;
          }

          .merchantInfo {
            display: flex;
            align-items: center;

            i {
              color: #3d7fff;
              font-size: 25px;
              cursor: pointer;
              padding-left: 5px;
              display: block;
            }

            img {
              display: block;
              // padding-right: 5px;
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
            }
          }

          .complainBtn {
            color: #999;
            position: absolute;
            right: 20px;
          }
        }

        .itemBottom {
          display: flex;
          align-items: center;
          color: #333;
          font-size: 13px;

          .orderInfo {
            padding: 20px;
            display: flex;
            align-items: center;
            border-right: 1px solid #efefef;
            justify-content: center;
            .orderInfoImg {
              margin-right: 30px;
              text-align: center;
              button {
                width: 100%;
                margin-top: 7px;
                background: #fff;
                color: #0c75d3;
                border: 1px solid #0c75d3;
                border-radius: 4px;
              }
            }
            img {
              display: block;
              width: 100px;
              height: 100px;
              border-radius: 10px;
            }

            .infoContent {
              .infoName {
                font-size: 14px;
                color: #000000;
                padding-bottom: 10px;
              }

              .infoOther {
                font-size: 13px;
                color: #999999;
                padding-bottom: 8px;
              }
            }
          }

          .arguments {
            padding: 20px;
          }

          .argumentsName {
            padding-bottom: 8px;
          }
          .payment {
            h3 {
              font-size: 14px;
              font-weight: 700;
              margin: 0;
            }

            .title {
              font-size: 12px;
              color: #999999;
            }
            .operationBtn {
              display: block;
              color: #0c75d3;
              text-align: center;
              width: 100%;
              margin: 0;
            }
          }
          .status {
            font-size: 14px;
          }
          .operationBtn {
            display: block;
            color: #0c75d3;
            text-align: center;
            width: 100%;
            margin: 0;
          }
          .operationBtnMoney {
            color: #0c75d3;
            padding: 6px 20px;
            border: 1px solid #0c75d3;
            border-radius: 6px;
          }
        }
      }
    }

    .name {
      flex: 1;
    }

    .price {
      width: 220px;
      text-align: center;
      margin: 0 20px;
    }

    .num {
      width: 95px;
      text-align: center;
    }

    .arguments {
      width: 294px;
    }

    .payment {
      width: 162px;
      text-align: center;
    }

    .status {
      width: 124px;
      text-align: center;
    }

    .operation {
      width: 145px;
      text-align: center;
    }
  }
  .pagination {
    margin-top: 20px;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/modelOrderList.vue